import { render, staticRenderFns } from "./SProgressBar.vue?vue&type=template&id=610a4fbe&scoped=true&"
import script from "./SProgressBar.vue?vue&type=script&lang=js&"
export * from "./SProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./SProgressBar.vue?vue&type=style&index=0&id=610a4fbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a4fbe",
  null
  
)

export default component.exports